import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fonts, glyphs, useMediaQuery } from '../../../Styles';
import { NewInput } from '../..';
import { ButtonTypes, NewFieldStyles, NewInputHandles } from '../../../Definitions';

// TODO
import Setting from '../../Settings/setting';
import { useAppSelector } from '../../../Store';
import { useUser } from '../../../Services/Agrisys_GqlDataCaller/UserCalls/dataCalls';
import { WorkerList } from './workerList';
import { NewButtonList } from '../../BaseComponents/newButton';

export default function UserAdministration() {
  const { t } = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 570px)`);
  const responsiveBox = useMediaQuery(`(max-width: 1420px)`);
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const inputRef = useRef<NewInputHandles>(null);

  const { getWorkerList, addDomainWorker, removeDomainUser } = useUser();

  useEffect(() => {
    getWorkerList(farm, true).then(e=>{if(!e) getWorkerList(farm)});
  },[farm])

  //TODO: only be able to add users if owner or admin
  return (
    <div style={{ display: "flex", gap: "20px", alignItems: mobileXs ? "center" : "end", justifyContent: "center", flexDirection: "column", width: !responsiveBox ? "1050px" : "100%" }}>
      <Setting startEnhancer={glyphs.User({ size: "25px" })} header={t("globalSettingsPages.globalSettings.userManagement", { defaultValue: "user management" })} content={
        <>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", justifyContent: mobileXs ? "center" : "start" }}>
            <NewInput
              placeholder={t("user.userName", { defaultValue: "username" })}
              fieldOverrides={{
                fieldStyle: NewFieldStyles.greyTertiary
              }}
              isDisabled={false}
              ref={inputRef}
            />
            <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
              <NewButtonList
                contents={[t("buttons.add", { defaultValue: "add" }), t("globalSettingsPages.globalSettings.remove", { defaultValue: "remove" })]}
                overrides={{
                  baseStyles: { width: "fit-content", backgroundColor: colors.greyTertiary, height: "30px", padding: "0 10px" },
                  contentStyles: { color: colors.greyDarkPrimary, textShadow: "none", ...fonts.fontSize4 },
                  hoverStyles: { backgroundColor: colors.greyLightPrimary, color: colors.greyDarkPrimary }
                }}
                disabled={[false, false]}
                onClick={(i => {
                  const username = inputRef.current?.value;
                  if (!username || typeof username !== "string") return;

                  if (i === 0) {
                    addDomainWorker(farm, username).then(() => {
                      getWorkerList(farm, true).then(e=>{if(!e) getWorkerList(farm)});
                    });
                  }
                  if (i === 1) {
                    removeDomainUser(farm, username);
                  }
                })}
              />
            </div>
          </div>
          <div style={{ height: "2px", backgroundColor: colors.greyLightPrimary, width: "100%", margin: "15px 0" }} />
          <WorkerList/>
        </>
      }/>
    </div>
  );
}